module.exports = __webpack_public_path__ + "img/Ariya.163456cc.png";